import React from 'react';
import clsx from 'clsx';
import {getIsSDKLimitedMode} from '../../utils/sdk';
import languageIcon from '../../assets/icons/language-icon.svg?no-inline';
import LanguageSelection, {LanguageSelectionRef} from '../ModalSheets/LanguageSelection';
import {Wrapper} from './styled';

type Props = {
  className?: string;
};
function LanguageSDKSwitcher({className}: Props) {
  const languageSelectionModalRef = React.useRef<LanguageSelectionRef>(null);

  if (!getIsSDKLimitedMode()) {
    return null;
  }

  return (
    <Wrapper
      onClick={languageSelectionModalRef.current?.open}
      className={clsx(className, 'sdk-lang-switcher')}
    >
      <img src={languageIcon} width={20} height={20} alt="Change language" />
      <LanguageSelection ref={languageSelectionModalRef} />
    </Wrapper>
  );
}

export {LanguageSDKSwitcher};
